import { render, staticRenderFns } from "./PracticePrograms.vue?vue&type=template&id=8cd93ad8&scoped=true&"
import script from "./PracticePrograms.vue?vue&type=script&lang=js&"
export * from "./PracticePrograms.vue?vue&type=script&lang=js&"
import style0 from "./PracticePrograms.vue?vue&type=style&index=0&id=8cd93ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd93ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VIcon,VOverlay,VProgressCircular,VSwitch})
